import { EnvService } from "../../environments/environment.factory";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { UserResponse } from "../../models/responses/user.response";
import { prepareAuthHeaders } from "../headers";

/*
  Generated class for the UserProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class UserProvider {
  private environment: any;

  constructor(public http: HttpClient, private env: EnvService) {
    this.environment = env;
  }

  index() {
    let headers = prepareAuthHeaders();
    return this.http.get<UserResponse>(`${this.environment.api}/v1/user`, {
      headers
    });
  }

  dias() {
    let headers = prepareAuthHeaders();
    return this.http.get<UserResponse>(`${this.environment.api}/v1/dias`, {
      headers
    });
  }

  create(request) {
    let headers = prepareAuthHeaders();
    return this.http.post(`${this.environment.api}/v1/user`, request, { headers });
  }

  update(request, id) {
    let headers = prepareAuthHeaders();
    return this.http.put(`${this.environment.api}/v1/user/${id}`, request, {
      headers
    });
  }

  destroy(request) {
    let headers = prepareAuthHeaders();
    return this.http.delete(`${this.environment.api}/v1/user/${request.id}`, {
      headers
    });
  }
}



// WEBPACK FOOTER //
// ./src/providers/user/user.ts